/* eslint-disable */ 
jQuery(document).ready(function ($) {

    var module_name = 'anchor_menu';
    $('.' + module_name.replace(/_/g, '-') + '-module').each(function (index) {

        module_name = '.' + module_name.replace(/_/g, '-') + '-module';
        // Add active class for current page
        var url = window.location.href;
        var hash = window.location.hash;

        $(module_name + ' a').each(function () {
            if ($(this).attr('href') == url) {
                $(this).parent().find('a').addClass('active');
            } else if ($(this).attr('href') == hash) {
                $(this).parent().find('a').addClass('active');
            }
        });

        // Add active class on click
        $(module_name + ' a').click(function () {
            $(this).parent().parent().find('a').removeClass('active');
            $(this).addClass('active');
        });

        let lastModule;
        // Animate
        $(module_name + ' a.anchor').on('click', function (e) {
            e.preventDefault();
            if($('.slot-page').length > 0){
                if($(this).attr('href') == "#overview"){
                    $('.module-list-anchor .module').show();
                    Object.values(modules_object["anchor_menu"][0]).forEach(element => {
                        $(element).parents('.module').hide();
                    });
                }else{
                    if(lastModule == $($(this).attr('href')).parents('.module').attr('class')){
                        $('.module-list-anchor .module').hide();
                        $($(this).attr('href')).parents('.module').show();
                        $('html, body').animate({
                            scrollTop: $($(this).attr('href')).offset().top - 70
                        });
                    }else{
                        $('.module-list-anchor .module').hide();
                        $($(this).attr('href')).parents('.module').show();
                    }
                    lastModule = $($(this).attr('href')).parents('.module').attr('class');
                }
            }else{
                $('html, body').animate({
                    scrollTop: $($(this).attr('href')).offset().top - 70
                });
            }
        });

        //Hide modules
        if($('.slot-page').length > 0){
            Object.values(modules_object["anchor_menu"][0]).forEach(element => {
                $(element).parents('.module').hide();
            });
        }
        $('.anchor__dropdown-title').click(function () {
            $(this).toggleClass('no-border');
            $('.anchor__dropdown-list').toggleClass('active-dropdown');
        });
    });
});